import { useEffect } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from '../i18n';

/**
 * Syncs URL :lang param with i18next language.
 * If URL has no lang prefix, redirects to the detected/preferred language.
 */
export const LanguageSync = ({ children }) => {
  const { lang } = useParams();
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (lang && SUPPORTED_LANGUAGES.includes(lang)) {
      // Sync URL lang to i18n
      if (i18n.language !== lang) {
        i18n.changeLanguage(lang);
      }
      // Always sync html lang (covers first paint case)
      if (typeof document !== 'undefined') {
        document.documentElement.lang = lang;
      }
      return;
    }
    // No valid lang in URL → redirect to detected/saved one
    const detected = (i18n.language || 'en').split('-')[0];
    const target = SUPPORTED_LANGUAGES.includes(detected) ? detected : 'en';
    const cleanPath = location.pathname.replace(/^\/+/, '');
    navigate(`/${target}${cleanPath ? '/' + cleanPath : ''}${location.hash}`, { replace: true });
  }, [lang, i18n, location, navigate]);

  return children;
};
